import AttributesCoVSoundField from './AttributesCoVSoundField'

export default AttributesCoVSoundField
